"use client";

import { Button } from "@nextui-org/button";
import { ActiveFilters } from "./ActiveFilters";
import { FiltersList } from "./FiltersList";
import { IoArrowBack, IoFilter, IoCloseOutline } from "react-icons/io5";

import { useState } from "react";
const Modal = ({ isOpen, onClose, children }) => {
  const handleClick = (e) => {
    e.stopPropagation(); // Detener la propagación del evento de clic
  };
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="modal-overlay fixed inset-0 bg-white overflow-auto"
        onClick={handleClick}
      >
        <div className="modal-container p-5 ">
          <div className="flex flex-col">
            <div className="flex flex-row justify-between items-center mb-4 ">
              <span className="text-lg font-bold">Filtros</span>
              <span
                className="modal-close cursor-pointer text-lg"
                onClick={onClose}
              >
                <IoCloseOutline />
              </span>
            </div>
            <div>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function ModalFilterSearch({ facets, filters, fullUrl }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="md:hidden my-5">
      <div className="flex flex-wrap gap-3">
        <Button
          color="primary"
          variant="bordered"
          endContent={<IoFilter />}
          onPress={openModal}
        >
          Filtros
        </Button>
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ActiveFilters filters={filters} fullUrl={fullUrl} />
        <FiltersList facets={facets} fullUrl={fullUrl} />
        <Button
          color="primary"
          variant="ghost"
          onPress={closeModal}
          className="z-50"
          startContent={<IoArrowBack />}
        >
          Volver
        </Button>
      </Modal>
    </div>
  );
}
